import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';


const Success = () => {


  return (
    <div className="flex items-center justify-center h-screen bg-green-100">
      <Confetti width={window.innerWidth} height={window.innerHeight} />
      <div className="text-center">
     
          <>
            <h1 className="text-4xl font-bold text-green-700 mb-4">Payment Successful!</h1>
            <p className="text-xl text-gray-700 mb-8">Thank you for your generous donation.</p>
            <div className="py-2 px-4 bg-green-500 text-white font-bold rounded-full animate-bounce">You are amazing!</div>
          </>
        
      </div>
    </div>
  );
};

export default Success;
